require('font-awesome/css/font-awesome.css');
require('bootstrap/dist/css/bootstrap.css');
require('../styles/styles.less');

import './promise-polyfill'
import { app } from './app'

app.$mount('#app');



// WEBPACK FOOTER //
// ./client/index.js